import { Card, Col, Row } from "react-bootstrap";
import { INonComplianceDetails } from "../../../api/INonCompliance";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { NonComplianceIcon } from "../../../leap-components/icons/LeapIcons";

interface IncidentHeaderProps {
  nonComplianceDetails: INonComplianceDetails;
  licenceProfile: ILicenceProfile;
}

const NonComplianceHeader = ({
  nonComplianceDetails,
  licenceProfile,
}: IncidentHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <NonComplianceIcon />
                  </td>
                  <td>
                    <h2>Non Compliance: {nonComplianceDetails.reference}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={nonComplianceDetails.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Status"}
              value={nonComplianceDetails.status}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={nonComplianceDetails.licenceDetails.reg_no}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default NonComplianceHeader;
